module.exports = __webpack_public_path__ + "static/media/sagaunknown.49f880f2.svg";